export const applyCardStyle = (imgPosition: string | undefined) => {
  if (imgPosition === 'right') return 'gap-32 md:gap-24 md:flex-row';
  if (imgPosition === 'left')
    return 'gap-32 md:gap-24 md:flex-row-reverse';

  return '';
};

export const applyImgStyle = (imgPosition: string | undefined) => {
  if (imgPosition === 'top') return 'h-[264px] mb-32';
  if (imgPosition === 'right' || imgPosition === 'left')
    return 'md:w-1/2 h-[264px] md:h-[318px]';

  return 'hidden';
};

export const applyCardContentStyle = (imgPosition: string | undefined) => {
  if (imgPosition === 'right' || imgPosition === 'left')
    return 'md:my-auto w-full md:w-1/2';

  return '';
};
